/* Copyright (c) 2023 GRIP.S Medien GmbH & Co.KG */

import { lazy } from 'react';

const load = (imp) => lazy(() => imp);

const pages = {
  dashboard: import(
    /* webpackChunkName: "pages.dashboard" */
    '../pages/Dashboard'
  ),
  users: import(
    /* webpackChunkName: "pages.users" */
    '../pages/users'
  ),
  settings: import(
    /* webpackChunkName: "pages.settings" */
    '../pages/Settings'
  ),
  projects: import(
    /* webpackChunkName: "pages.projects" */
    '../pages/projects/list'
  ),
  projectsDetails: import(
    /* webpackChunkName: "pages.projects" */
    '../pages/projects/view'
  ),
  projectsPrint: import(
    /* webpackChunkName: "pages.projects" */
    '../pages/projects/print'
  ),
};

const routes = [
  {
    id: 'dashboard',
    handler: load(pages.dashboard),
    path: '/',
    scopes: ['viewer', 'user', 'admin'],
    exact: true,
  },
  {
    id: 'users',
    handler: load(pages.users),
    path: '/users',
    scopes: ['admin'],
    exact: true,
  },
  {
    id: 'settings',
    handler: load(pages.settings),
    path: '/settings',
    scopes: ['admin'],
    exact: true,
  },
  {
    id: 'projects',
    handler: load(pages.projects),
    path: '/projects',
    scopes: ['viewer', 'user', 'admin'],
    exact: true,
  },
  {
    id: 'projects',
    handler: load(pages.projectsPrint),
    path: '/projects/print',
    scopes: ['viewer', 'user', 'admin'],
    exact: true,
  },
  {
    id: 'projects',
    handler: load(pages.projectsDetails),
    path: '/projects/:ref',
    scopes: ['viewer', 'user', 'admin'],
    exact: true,
  },
];

export { routes as default };
